import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  loadDrawer: false,
  leadData: [],
  leadCount: 0,
  manualLeads: [],
  count: 0,
  currentLead: {},
  currentplatform: "",
  error: {},
  previewPayload: {},
  permissionsData: [],
}

export const fetchLeadData = createAsyncThunk('leadSlice/fetchLeadData', async (data, thunkAPI) => {
  try {
    let baseUrl = `/leads?page=${data?.page}&page_size=${data.page_size}&is_sold=${data.is_sold ? true : false}`;
    // Append query parameters based on conditions
    if (data?.source) {
      baseUrl += `&source=${data?.source}`;
    }
    if (data.industry_id && data.platform_id) {
      baseUrl += `&industry_id=${data.industry_id}&platform_id=${data.platform_id}`;
    } else if (data.industry_id) {
      baseUrl += `&industry_id=${data.industry_id}`;
    } else if (data.platform_id) {
      baseUrl += `&platform_id=${data.platform_id}`;
    }
    console.log("data.comment_type", baseUrl);
    if (data.feed_type) {
      baseUrl += `&feed_type=${data.feed_type}`;
    }
    if (data.comment_type) {
      baseUrl += `&comment_type=${data.comment_type}`;
    }
    // let url = data.industry_id && data.platform_id  ? `/leads?industry_id=${data.industry_id}&platform_id=${data.platform_id}&page=${data?.page}&page_size=${data.page_size}` :`/leads?page=${data?.page}&page_size=${data.page_size}`
    // if (typeof data.is_replied === "boolean") {
    //   baseUrl += `&is_replied=${data.is_replied}`;
    // }
    if (data?.sold_to) {
      baseUrl += `&sold_to=${data?.sold_to}`;
    }
    if (data?.ordering) {
      baseUrl += `&ordering=${data?.ordering}`;
    }

    if (data?.location) {
      baseUrl += `&location_id=${data?.location}`;
    }
    if (data?.category) {
      baseUrl += `&category=${data?.category}`;
    }

    // let url = data.industry_id && data.platform_id  ? `/leads?industry_id=${data.industry_id}&platform_id=${data.platform_id}&page=${data?.page}&page_size=${data.page_size}` :`/leads?page=${data?.page}&page_size=${data.page_size}`
    const response = await axiosInstance.get(baseUrl);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const fetchLeadById = createAsyncThunk('leadSlice/fetchLeadById', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/leads/${values.id}?source=${values.platform}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const exportLeads = createAsyncThunk('leadSlice/exportLeads', async (values, thunkAPI) => {
  console.log("values", values);

  try {
    const response = await axiosInstance.post(`/leads/export_leads`, values);
    return response;
    // const blob = await response.blob();
    // return { data: blob }; // Store Blob in Redux
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

// manual leads thunk actions

export const fetchManualLeads = createAsyncThunk('leadSlice/fetchManualLeads', async (query, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`leads/manual${query}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const fetchManualLeadById = createAsyncThunk('leadSlice/fetchManualLeadById', async (uuid, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`leads/manual/${uuid}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const createLead = createAsyncThunk('leadSlice/createLead', async (data, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/leads/manual`, data);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const updateLead = createAsyncThunk('leadSlice/updateLead', async (data, thunkAPI) => {
  console.log("v", data);

  try {
    const response = await axiosInstance.patch(`/leads/manual/${data.uuid}`, data);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const deleteLead = createAsyncThunk('leadSlice/deleteLead', async (uuid, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/leads/manual/${uuid}`);
    response.data = uuid;
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const toggleActivation = createAsyncThunk('leadSlice/toggleActivation', async (uuid, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/leads/manual/${uuid}/toggle-activation`);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const leadSlice = createSlice({
  name: 'leadSlice',
  initialState,
  reducers: {
    setPreviewPayload: (state, action) => {
      state.previewPayload = action.payload; // Update previewPayload state
    }
  },
  extraReducers: (builder) => {
    //fetch leads data
    builder.addCase(fetchLeadData.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.leadData = []
    });
    builder.addCase(fetchLeadData.fulfilled, (state, action) => {
      state.leadData = action.payload?.data?.results;
      state.leadCount = action.payload?.data.count
      state.loading = false;
    });
    builder.addCase(fetchLeadData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //fetch lead by id
    builder.addCase(fetchLeadById.pending, (state) => {
      state.loadDrawer = true;
      state.error = null;
      state.currentLead = {}
    });
    builder.addCase(fetchLeadById.fulfilled, (state, action) => {
      console.log("lead fetch by id", action);
      state.loadDrawer = false;
      state.currentLead = action.payload?.data
    });
    builder.addCase(fetchLeadById.rejected, (state, action) => {
      state.error = action.payload;
      state.loadDrawer = false;
    });
    // manual leads
    builder.addCase(fetchManualLeads.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchManualLeads.fulfilled, (state, action) => {
      state.manualLeads = action.payload?.data?.results;
      state.count = action.payload?.data.count;
      state.loading = false;
    });
    builder.addCase(fetchManualLeads.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(fetchManualLeadById.pending, (state) => {
      state.loadDrawer = true;
      state.error = null;
    });
    builder.addCase(fetchManualLeadById.fulfilled, (state, action) => {
      console.log("lead manual fetch by id", action);
      state.currentLead = action.payload?.data
      state.loadDrawer = false;
    });
    builder.addCase(fetchManualLeadById.rejected, (state, action) => {
      state.loadDrawer = false;
      state.error = action.payload;
    });

    builder.addCase(toggleActivation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(toggleActivation.fulfilled, (state, action) => {
      const id = action?.payload?.data?.data?.id;
      state.manualLeads = state.manualLeads.map(platform =>
        platform.id === id ? action?.payload?.data?.data : platform
      );
      state.error = null;
      state.loading = false;
      if (action?.payload?.status == 200) {
        toast.success("Lead updated successfully")
      }
    });
    builder.addCase(toggleActivation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteLead.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(deleteLead.fulfilled, (state, action) => {
      state.manualLeads = state.manualLeads.filter((ele) => ele.uuid !== action?.payload?.data);
      if (action?.payload?.status == 204) {
        toast.success("Lead deleted successfully")
      }
      state.loading = false;
      state.error = null;
    });

    builder.addCase(deleteLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(createLead.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createLead.fulfilled, (state, action) => {
      state.manualLeads = [action?.payload?.data.data, ...state.manualLeads];
      state.loading = false;
      state.error = null;
      if (action?.payload?.status == 201) {
        toast.success("Lead created successfully")

      }
    });
    builder.addCase(createLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(updateLead.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateLead.fulfilled, (state, action) => {
      state.loading = false;
      const updatedLead = action.payload?.data?.data;
      if (action.payload.status == 200) {
        state.manualLeads = state.manualLeads.map(platform =>
          platform.id === updatedLead.id ? updatedLead : platform
        );
        toast.success("Lead updated Successfully !")
      }
    });
    builder.addCase(updateLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
})
export const { setPreviewPayload } = leadSlice.actions;


export default leadSlice.reducer